import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
    root: {
        border: "none",
        height: "100%",
        borderRadius: "0px 18px 18px 0px",
        backgroundColor: `${theme.palette.blue[6]} !important`,
        overflowX: "hidden",
    },
    drawer: {
        width: theme.spacing(32),
        flexShrink: 0,
        whiteSpace: "nowrap",
        position: "absolute",
        zIndex: 1400
    },
    drawerOpen: {
        width: theme.spacing(32),
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: "hidden",
        width: theme.spacing(8)
    },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: theme.spacing(0, 1, 0, 2),
        height: theme.spacing(6.5),
        boxShadow: '0 8px 6px -6px rgba(255,255,255,0.25)',
        borderBottom: `1px solid ${theme.palette.common.white}`,
    },
    list: {
        background: `${theme.palette.common.white} !important`,
        color: theme.palette.blue[6],
        "& svg": {
            color: theme.palette.blue[6],
        }

    },
    imageView: {
        alignItems: "center",
        "& img": {
            height: theme.spacing(4),
            width: theme.spacing(4)
        },
        "& span": {
            paddingLeft: theme.spacing(1),
            color: theme.palette.common.white,
            fontWeight: 500,
            letterSpacing: "1px"

        },
    },
    itemList: {
        display: "flex",
        color: theme.palette.common.white,
        opacity: 0.9,
        margin: "8px 0",
        cursor: "pointer",
        borderRadius: "8px !important",
        "& svg": {
            color: theme.palette.common.white,
        },
        "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.25)",
            borderRadius: "8px !important",
        },
        "& span": {
            fontWeight: 400,
        }
    },
    selectedItem: {
        opacity: 1,
        color: `${theme.palette.blue[6]} !important`,
        backgroundColor: `${theme.palette.common.white} !important`,
        borderRadius: "8px!important",
        "& span": {
            fontWeight: 600,
        },
        "&:hover": {
            opacity: 1,
            color: theme.palette.blue[6],
            backgroundColor: "rgba(255, 255, 255)",
        },
        "& svg": {
            color: theme.palette.blue[6],
        }
    },
}));
